export enum ESocketEvent {
	NewExpense = 'new-expense',
	NewIncome = 'new-income',
}
